export const scrollToBottom = (ref) => {
  ref.current?.scrollIntoView({ behavior: "smooth" });
};

export const calculateHeaderHeight = () => {
  const header = document.querySelector(".header");
  if (header) {
    return header.offsetHeight;
  }
};
